import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  Stack,
  InputLabel,
  FormControl,
  Divider,
  Autocomplete,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import {
  ExpandMore,
  KeyboardArrowLeft,
  PriorityHigh,
} from "@mui/icons-material";
import UnsavedPopup from "./UnsavedPopup";
import {
  getMonth,
  getTodaysDate,
  setupInitialDate,
  convertToDDMMYYYY,
  convertToYYYYMMDD,
} from "../utils/utils";
import AudioUploadComponent from "./AudioUploadComponent";
import AudioRecording from "./AudioRecording";
// import FileUploadComponent from "./AudioUploadComponent";

const CustomerForm = ({
  setCurrentTab,
  sheetData,
  editForm,
  selectedCustomer,
  setSelectedCustomer,
  showEditForm,
  getSheetData,
  showUnsavedPopup,
  setShowUnsavedPopup,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  handlePopupExit,
  appFields,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(() => {
    const savedData = showEditForm
      ? selectedCustomer
      : JSON.parse(localStorage.getItem(showEditForm ? "editFormData" : "addFormData"));
    return savedData ? savedData : {};
  });

  const [newFollowUp, setNewFollowUp] = useState({});
  const [followUpCount, setFollowUpCount] = useState(0);
  const [dataToSend, setDataToSend] = useState({});
  const [audioPopupNumber, setAudioPopupNumber] = useState(0);
  const [responsePC, setResponsePC] = useState({
    prospectCardNo: null,
    message: "",
  });
  const [showRecordPopup, setShowRecordPopup] = useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [pcError, setPCError] = useState(false);

  const handleChange = (e, value, name) => {
    setHasUnsavedChanges(true);
  
    if (e) {
      const { name, value } = e.target; // Use destructured variables without shadowing
      const regex = /^\d+$/;
      if (
        (name === "Contact No." || name === "Contact No. 2") &&
        (value.length > 10 || !regex.test(value))
      )
        return;
      if (name === "Prospect Card No." && (value?.length > 0 && !regex.test(value))) return;      
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prevData) => {
      const supportRequired = prevData?.["Support Required"] || "";
      if (checked) {
        // Add the value if checked
        return {
          ...prevData,
          "Support Required":
            supportRequired?.length > 0 ? supportRequired + "," + name : name,
        };
      } else {
        // Remove the value if unchecked
        let temp = supportRequired?.split(",").filter((item) => item !== name);
        return {
          ...prevData,
          "Support Required": temp.join(","),
        };
      }
    });
  };

  useEffect(() => {
    if (Object?.keys(formData)?.length > 1) {
      setHasUnsavedChanges(true);
      showEditForm ? localStorage.setItem("editFormData", JSON.stringify(formData)) :localStorage.setItem("addFormData", JSON.stringify(formData));  
    }   
  }, [formData]);


  const handleSubmit = (e) => {
    setDataToSend({});

    e.preventDefault();
    setLoading(true);
    let temp = {
      ...formData,
    };
    if (!showEditForm) {
      temp = {
        ...temp,
        Month: getMonth(),
      };
    }
    if (followUpCount > 0) {
      temp = {
        ...temp,
        "Last Follow-up Date": formData[`Follow-up ${followUpCount} Date`],
        "Last Follow-up Remark": formData[`Follow-up ${followUpCount} Remark`],
        "Next Follow-up Date": formData[`Next Follow-up ${followUpCount} Date`],
      };
    }
    setFormData({ ...temp });
    Object.keys(temp)?.map((key) => {
      if (key?.toLowerCase()?.includes("date") && temp[key]?.length > 0) {
        temp[key] = convertToDDMMYYYY(temp[key]);
      }
    });
    if (temp["Month"]?.includes("-")) {
      temp = {
        ...temp,
        Month: convertToDDMMYYYY(temp["Month"]),
      };
    }
    setDataToSend({ ...temp });
  };

  const updateCustomerData = () => {
    const urlEncodedData = new URLSearchParams();
    for (const key in formData) {
      if (dataToSend.hasOwnProperty(key)) {
        urlEncodedData.append(key, dataToSend[key]);
      }
    }

    // Get the token from localStorage
    const token = localStorage.getItem("token");

    // Perform the fetch request
    fetch(`${process.env.REACT_APP_BACKEND_URL}/updateCustomers`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        "Content-Type": "application/x-www-form-urlencoded", // Specify the content type
      },
      body: urlEncodedData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the JSON from the response
      })
      .then((data) => {
        console.log("Update successful:", data);
        // Handle success (e.g., show a success message, clear form, etc.)
        setResponsePC({
          prospectCardNo: data?.prospectCardNo,
          message: !editForm ? "Created" : "Updated",
        });
        setTimeout(() => {
          localStorage.removeItem("addFormData");
          localStorage.removeItem("editFormData");
        }, 1000);
        getSheetData();
        setSelectedCustomer({});
        setHasUnsavedChanges(false);
      })
      .catch((error) => {
        console.error("Error updating customer:", error);
        // Handle error (e.g., show an error message to the user)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAddNewFollowup = () => {
    setFormData((prev) => ({
      ...prev,
      ...newFollowUp,
    }));
    // localStorage.setItem("formData", { ...formData, ...newFollowUp });
    setFollowUpCount((prevCount) => prevCount + 1);
    setNewFollowUp({});
  };

  const handleExit = () => {
    setCurrentTab(null);
    setSelectedCustomer({});
    setShowUnsavedPopup(false);
    setHasUnsavedChanges(false);
    setTimeout(() => {
      localStorage.removeItem("addFormData");
      localStorage.removeItem("editFormData");
    }, 1000);
  };

  useEffect(() => {
    if (editForm && selectedCustomer) {

      let avaiableFollowUps = 0;
      for (let i = 1; i <= 10; i++) {
        if (
          selectedCustomer[`Follow-up ${i} Date`] &&
          selectedCustomer[`Follow-up ${i} Date`]?.length > 0
        ) {
          continue;
        } else {
          avaiableFollowUps = i - 1;
          break;
        }
      }

      setFollowUpCount(avaiableFollowUps);
    }
  }, [selectedCustomer]);

  const handleProspectCardCheck = () => {
    if (
      formData?.["Prospect Card No."] &&
      formData?.["Prospect Card No."]?.length > 0
    ) {
      let tempArray = sheetData?.map((dataItem) => {
        return dataItem?.["Prospect Card No."];
      });
      if (tempArray?.includes(formData?.["Prospect Card No."])) {
        setPCError(true);
      }
    }
  };

  const checkMissingFields = () => {
    const requiredFields = [
      "Prospect Card No.",
      "Sales Consultant",
      "Actual Date",
      "Enquiry Type",
      "Customer Name",
      "Contact No.",
      "Test Drive Given",
    ];

    const tempMissingFields = [];

    requiredFields.forEach((field) => {
      if (!dataToSend?.[field] || dataToSend?.[field] === 0) {
        tempMissingFields.push(field);
      }
    });

    // Update the state with missing fields
    setMissingFields(tempMissingFields);
    console.log(tempMissingFields);

    // If any fields are missing, stop further execution
    return tempMissingFields?.length > 0 ? true : false;
  };

  useEffect(() => {
    
    if (loading && Object.keys(dataToSend)?.length > 0) {
      if (checkMissingFields()) {
        setLoading(false);
        return;
      }
      updateCustomerData();
    }
  }, [dataToSend]);

  useEffect(() => {
    let tempFormData = { ...formData };

    if (!editForm) {
      if (
        localStorage.getItem("role") &&
        localStorage.getItem("role") !== "Head"
      ) {
        tempFormData = {
          ...tempFormData,
          "Sales Consultant": localStorage.getItem("name"),
        };
      }
      tempFormData = { ...tempFormData, "Actual Date": getTodaysDate() };
    }
    setFormData(tempFormData);
    // localStorage.setItem("formData", tempFormData);
  }, [editForm, sheetData]);

  return (
    <>
      {!editForm && (
        <Button
          variant="outlined"
          className="navigaton_button"
          onClick={() => {
            if (hasUnsavedChanges) {
              setShowUnsavedPopup(true);
            } else {
              setCurrentTab(null);
              setSelectedCustomer({});
              // setShowEditForm(false)
            }
          }}
        >
          <KeyboardArrowLeft /> Back to Home
        </Button>
      )}
      <Container maxWidth="sm" className="CustomerFormContainer">
        <Typography fullWidth variant="h6" className="section_header">
          {showEditForm ? "" : "ADD NEW"}
        </Typography>
        <form onSubmit={handleSubmit}>
          <Stack gap={2} marginBottom={2}>
            <TextField
              label="Prospect Card No."
              variant="outlined"
              fullWidth
              // disabled
              onChange={handleChange}
              margin="normal"
              name="Prospect Card No."
              value={formData["Prospect Card No."] || ""}
              onBlur={handleProspectCardCheck}
              onFocus={() => {
                setPCError(false);
              }}
              required
            />

            {pcError && (
              <Alert
                icon={<PriorityHigh fontSize="inherit" />}
                severity="error"
              >
                Prospect Card No. already exists. Navigate to <b>Edit</b>{" "}
                section to update.
              </Alert>
            )}
            {localStorage.getItem("role") &&
            localStorage.getItem("role") === "Head" ? (
              <FormControl fullWidth required>
                <InputLabel id="simple-select-label-consultant">
                  Sales Consultant
                </InputLabel>
                <Select
                  label="Sales Consultant"
                  name="Sales Consultant"
                  labelId="simple-select-label-consultant"
                  value={formData["Sales Consultant"] || ""}
                  onChange={handleChange}
                >
                  {appFields &&
                    appFields?.["Sales Consultant"]?.map((consultant) => (
                      <MenuItem key={consultant} value={consultant}>
                        {consultant}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            ) : (
              <TextField
                fullWidth
                label="Sales Consultant"
                name="Sales Consultant"
                value={formData["Sales Consultant"] || ""}
                disabled
              />
            )}

            <TextField
              label="Date"
              variant="outlined"
              fullWidth
              margin="normal"
              name="Actual Date"
              value={formData["Actual Date"] || ""}
              required
            />
            <FormControl fullWidth required>
              <InputLabel id="simple-select-label-enqtype">
                Enquiry Type
              </InputLabel>
              <Select
                labelId="simple-select-label-enqtype"
                label="Enquiry Type"
                name="Enquiry Type"
                value={formData["Enquiry Type"] || ""}
                onChange={handleChange}
              >
                {appFields &&
                  appFields?.["Enquiry Type"]?.map((type) => {
                    return <MenuItem value={type}>{type}</MenuItem>;
                  })}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Source"
              name="Source"
              value={formData["Source"] || ""}
              onChange={handleChange}
            />
          </Stack>

          <Stack gap={2}>
            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Customer Profile
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  <TextField
                    label="Customer Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="Customer Name"
                    value={formData["Customer Name"] || ""}
                    onChange={handleChange}
                    required
                  />

                  <TextField
                    label="Contact No."
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="Contact No."
                    value={formData["Contact No."] || ""}
                    onChange={handleChange}
                    required
                  />

                  <TextField
                    label="Contact No. 2"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="Contact No. 2"
                    value={formData["Contact No. 2"] || ""}
                    onChange={handleChange}
                  />

                  <TextField
                    label="E Mail ID"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="E Mail ID"
                    value={formData["E Mail ID"] || ""}
                    onChange={handleChange}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-age">
                      Age Group
                    </InputLabel>
                    <Select
                      name="Age Group"
                      label="Age Group"
                      value={formData["Age Group"] || ""}
                      className="CustomerFormSelect"
                      labelId="simple-select-label-age"
                      onChange={handleChange}
                    >
                      {appFields &&
                        appFields["Age Group"]?.map((ageGroup) => {
                          return (
                            <MenuItem value={ageGroup}>{ageGroup}</MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>

                  <TextField
                    type="date"
                    focused
                    name="Date of Birth"
                    value={formData["Date of Birth"] || ""}
                    onChange={handleChange}
                    label="Date of Birth"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />

                  <TextField
                    label="Address"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="Address"
                    value={formData["Address"] || ""}
                    onChange={handleChange}
                  />

                  <TextField
                    label="Location"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="Location"
                    value={formData["Location"] || ""}
                    onChange={handleChange}
                  />

                  <TextField
                    fullWidth
                    name="Profession"
                    label="Profession"
                    value={formData["Profession"] || ""}
                    onChange={handleChange}
                  />

                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        name="Present Car 1"
                        value={formData["Present Car 1"] || ""}
                        onChange={handleChange}
                        label="Present Car 1"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Present Car 1")
                    }
                  />
                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        name="Present Car 2"
                        value={formData["Present Car 2"] || ""}
                        onChange={handleChange}
                        label="Present Car 2"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Present Car 2")
                    }
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Understanding Needs
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-modeldetails">
                      Model Details
                    </InputLabel>
                    <Select
                      name="Model Details"
                      label="Model Details"
                      value={formData["Model Details"] || ""}
                      onChange={handleChange}
                      labelId="simple-select-label-modeldetails"
                    >
                      {appFields &&
                        appFields["Volkswagen Models"]?.map((vwmodel) => {
                          return <MenuItem value={vwmodel}>{vwmodel}</MenuItem>;
                        })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="Variant"
                    onChange={handleChange}
                    value={formData["Variant"] || ""}
                    label="Variant"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />

                  <TextField
                    type="date"
                    focused
                    name="Likely Date / Time of Purchase"
                    value={formData["Likely Date / Time of Purchase"] || ""}
                    onChange={handleChange}
                    label="Likely Date / Time of Purchase"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />

                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-vehicleuser">
                      User of Vehicle
                    </InputLabel>
                    <Select
                      name="User of Vehicle"
                      value={formData["User of Vehicle"] || ""}
                      onChange={handleChange}
                      label="User of Vehicle"
                      className="CustomerFormSelect"
                      labelId="simple-select-label-vehicleuser"
                    >
                      {appFields &&
                        appFields["User of Vehicle"]?.map((user) => {
                          return <MenuItem value={user}>{user}</MenuItem>;
                        })}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-usage">
                      Usage Preference
                    </InputLabel>
                    <Select
                      name="Usage Preference"
                      value={formData["Usage Preference"] || ""}
                      onChange={handleChange}
                      label="Usage Preference"
                      className="CustomerFormSelect"
                      labelId="simple-select-label-usage"
                    >
                      {appFields &&
                        appFields["Usage Preference"]?.map((usage) => {
                          return <MenuItem value={usage}>{usage}</MenuItem>;
                        })}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-driving">
                      Driving Preference
                    </InputLabel>
                    <Select
                      name="Driving Preference"
                      onChange={handleChange}
                      value={formData["Driving Preference"] || ""}
                      label="Driving Preference"
                      className="CustomerFormSelect"
                      labelId="simple-select-label-driving"
                    >
                      {appFields &&
                        appFields["Driving Preference"]?.map((preference) => {
                          return (
                            <MenuItem value={preference}>{preference}</MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>

                  <TextField
                    name="Distance Travelled Daily"
                    value={formData["Distance Travelled Daily"] || ""}
                    onChange={handleChange}
                    label="Distance Travelled Daily"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />

                  <TextField
                    name="Initial Comments"
                    onChange={handleChange}
                    value={formData["Initial Comments"] || ""}
                    label="Initial Comments"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    name="Budget"
                    onChange={handleChange}
                    value={formData["Budget"] || ""}
                    label="Budget"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />

                  <FormControl fullWidth>
                    <InputLabel id="simple-select-vfr">
                      Vehicle Finance Required
                    </InputLabel>
                    <Select
                      name="Vehicle Finance Required"
                      value={formData["Vehicle Finance Required"] || ""}
                      onChange={handleChange}
                      label="Vehicle Finance Required"
                      labelId="simple-select-vfr"
                    >
                      {["Yes", "No"]?.map((option) => {
                        return <MenuItem value={option}>{option}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="Preferred Banking Partner"
                    value={formData["Preferred Banking Partner"] || ""}
                    onChange={handleChange}
                    label="Preferred Banking Partner"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    name="% Funding Required"
                    value={formData["% Funding Required"] || ""}
                    onChange={handleChange}
                    label="% Funding Required"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    name="Tenure For Loan"
                    value={formData["Tenure For Loan"] || ""}
                    onChange={handleChange}
                    label="Tenure For Loan"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />

                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-tradein">
                      Trade-in Required
                    </InputLabel>
                    <Select
                      value={formData["Trade-in Required"] || ""}
                      name="Trade-in Required"
                      label="Trade-in Required"
                      labelId="simple-select-label-tradein"
                      onChange={handleChange}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Test Drive
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  <FormControl fullWidth required>
                    <InputLabel id="simple-select-label-tradein">
                      Test Drive Given
                    </InputLabel>
                    <Select
                      value={formData["Test Drive Given"] || ""}
                      name="Test Drive Given"
                      label="Test Drive Given"
                      labelId="simple-select-label-tdgiven"
                      onChange={handleChange}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    fullWidth
                    name="Gate Pass No."
                    value={formData["Gate Pass No."] || ""}
                    onChange={handleChange}
                    label="Gate Pass No."
                    disabled={
                      !(
                        formData?.["Test Drive Given"] &&
                        formData?.["Test Drive Given"] === "Yes"
                      )
                        ? true
                        : false
                    }
                  />
                  <TextField
                    name="Test Drive Comments"
                    value={formData["Test Drive Comments"] || ""}
                    onChange={handleChange}
                    label="Test Drive Comments"
                    disabled={
                      !(
                        formData?.["Test Drive Given"] &&
                        formData?.["Test Drive Given"] === "Yes"
                      )
                        ? true
                        : false
                    }
                  />
                  <TextField
                    type="number"
                    name="KM Run"
                    value={formData["KM Run"] || ""}
                    onChange={handleChange}
                    label="KM Run"
                    disabled={
                      !(
                        formData?.["Test Drive Given"] &&
                        formData?.["Test Drive Given"] === "Yes"
                      )
                        ? true
                        : false
                    }
                  />

                  <TextField
                    fullWidth
                    name="Test Drive Feedback"
                    value={formData["Test Drive Feedback"] || ""}
                    onChange={handleChange}
                    label="Test Drive Feedback"
                    disabled={
                      !(
                        formData?.["Test Drive Given"] &&
                        formData?.["Test Drive Given"] === "Yes"
                      )
                        ? true
                        : false
                    }
                  />

                  <FormControl
                    fullWidth
                    disabled={
                      !(
                        formData?.["Test Drive Given"] &&
                        formData?.["Test Drive Given"] === "Yes"
                      )
                        ? true
                        : false
                    }
                  >
                    <InputLabel id="simple-select-label-homevisit">
                      Home Visit
                    </InputLabel>
                    <Select
                      value={formData["Home Visit"] || ""}
                      name="Home Visit"
                      label="Home Visit"
                      labelId="simple-select-label-homevisit"
                      onChange={handleChange}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    focused
                    type="date"
                    name="Home Visit Date"
                    value={formData["Home Visit Date"]}
                    onChange={handleChange}
                    label="Home Visit Date"
                    disabled={
                      !(
                        formData?.["Test Drive Given"] &&
                        formData?.["Test Drive Given"] === "Yes"
                      )
                        ? true
                        : false
                    }
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Competition Profile
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Present Car 2"
                        variant="outlined"
                        name="Other Competition 1"
                        value={formData["Other Competition 1"] || ""}
                        onChange={handleChange}
                        label="Other Competition 1"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Other Competition 1")
                    }
                  />
                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Present Car 2"
                        variant="outlined"
                        name="Other Competition 2"
                        value={formData["Other Competition 2"] || ""}
                        onChange={handleChange}
                        label="Other Competition 2"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Other Competition 2")
                    }
                  />
                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Present Car 2"
                        variant="outlined"
                        name="Other Competition 3"
                        value={formData["Other Competition 3"] || ""}
                        onChange={handleChange}
                        label="Other Competition 3"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Other Competition 3")
                    }
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion
              disabled={
                !(
                  formData?.["Trade-in Required"] &&
                  formData?.["Trade-in Required"] === "Yes"
                )
              }
            >
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Trade-In
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  <TextField
                    name="Present Vehicle No."
                    value={formData["Present Vehicle No."] || ""}
                    onChange={handleChange}
                    label="Present Vehicle No."
                  />

                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option} // Since the options are strings, just return the option itself
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        name="Make - Model"
                        value={formData["Make - Model"] || ""}
                        onChange={handleChange}
                        label="Make - Model"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Make - Model")
                    }
                  />

                  <TextField
                    name="Trade-in Variant"
                    value={formData["Trade-in Variant"] || ""}
                    onChange={handleChange}
                    label="Trade-in Variant"
                  />
                  <TextField
                    type="number"
                    name="KM Driven"
                    value={formData["KM Driven"] || ""}
                    onChange={handleChange}
                    label="KM Driven"
                  />

                  <FormControl fullWidth>
                    <InputLabel id="simple-select-year">Model Year</InputLabel>
                    <Select
                      name="Model Year"
                      value={formData["Model Year"] || ""}
                      onChange={handleChange}
                      label="Model Year"
                      labelId="simple-select-year"
                    >
                      {Array.from(
                        { length: 15 },
                        (_, i) => new Date().getFullYear() - i
                      )?.map((year) => {
                        return <MenuItem value={year}>{year}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="Price Expected"
                    value={formData["Price Expected"] || ""}
                    onChange={handleChange}
                    label="Price Expected"
                  />
                  <TextField
                    name="Price Offer"
                    value={formData["Price Offer"] || ""}
                    onChange={handleChange}
                    label="Price Offer"
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Lead Closure Segment
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  <FormControl fullWidth>
                    <InputLabel id="simple-select-label-status">
                      Lead Status
                    </InputLabel>
                    <Select
                      name="Lead Status"
                      onChange={handleChange}
                      value={formData["Lead Status"] || ""}
                      label="Lead Status"
                      labelId="simple-select-label-status"
                    >
                      {appFields?.["Lead Status"]?.map((status) => {
                        return <MenuItem value={status}>{status}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="Date of Prospect Card Closure"
                    type="date"
                    focused
                    value={formData["Date of Prospect Card Closure"] || ""}
                    onChange={handleChange}
                    label="Date of Prospect Card Closure"
                  />
                  <TextField
                    type="date"
                    focused
                    name="Date of SDFC Updation"
                    value={formData["Date of SDFC Updation"] || ""}
                    onChange={handleChange}
                    label="Date of SDFC Updation"
                  />

                  <FormControl fullWidth>
                    <InputLabel id="simple-select-lcc">
                      Lost to Competition
                    </InputLabel>
                    <Select
                      name="Lost to Competition"
                      value={formData["Lost to Competition"] || ""}
                      onChange={handleChange}
                      label="Lost to Competition"
                      labelId="simple-select-lcc"
                    >
                      {["Yes", "No"]?.map((option) => {
                        return <MenuItem value={option}>{option}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="Lost to Co-Dealer"
                    onChange={handleChange}
                    value={formData["Lost to Co-Dealer"] || ""}
                    label="Lost to Co-Dealer"
                  />

                  <Autocomplete
                    fullWidth
                    options={appFields?.["Make And Models"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        name="Lost To - Vehicle"
                        value={formData["Lost To - Vehicle"] || ""}
                        onChange={handleChange}
                        label="Lost To - Vehicle"
                      />
                    )}
                    onChange={(event, value) =>
                      handleChange(null, value, "Lost To - Vehicle")
                    }
                  />

                  <TextField
                    name="Lost To - Variant"
                    value={formData["Lost To - Variant"] || ""}
                    onChange={handleChange}
                    label="Lost To - Variant"
                  />

                  <FormControl fullWidth>
                    <InputLabel id="simple-select-rolb">
                      Reason of Lost Bucket
                    </InputLabel>
                    <Select
                      name="Reason of Lost Bucket"
                      value={formData["Reason of Lost Bucket"] || ""}
                      onChange={handleChange}
                      label="Reason of Lost Bucket"
                      labelId="simple-select-rolb"
                    >
                      {appFields &&
                        appFields?.["Reason of Lost Bucket"]?.map((option) => {
                          return <MenuItem value={option}>{option}</MenuItem>;
                        })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="Reason of Lost Details"
                    value={formData["Reason of Lost Details"] || ""}
                    onChange={handleChange}
                    label="Reason of Lost Details"
                  />
                  <TextField
                    type="date"
                    focused
                    name="Date of Lead Closure"
                    value={formData["Date of Lead Closure"] || ""}
                    onChange={handleChange}
                    label="Date of Lead Closure"
                  />
                  <TextField
                    name="Remark"
                    value={formData["Remark"] || ""}
                    onChange={handleChange}
                    label="Remark"
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Follow-ups
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2}>
                  {followUpCount > 0 &&
                    Array.from({ length: followUpCount })?.map((_, i) => {
                      return (
                        <React.Fragment key={i}>
                          <Typography variant="caption">{`Follow-up ${
                            i + 1
                          }`}</Typography>
                          <TextField
                            name={`Follow-up ${i + 1} Date`}
                            value={formData[`Follow-up ${i + 1} Date`] || ""}
                          />
                          <TextField
                            name={`Follow-up ${i + 1} Remark`}
                            value={formData[`Follow-up ${i + 1} Remark`] || ""}
                          />
                          <TextField
                            name={`Next Follow-up ${i + 1} Date`}
                            value={
                              formData[`Next Follow-up ${i + 1} Date`] || ""
                            }
                          />
                          <Divider />
                        </React.Fragment>
                      );
                    })}
                  <Typography variant="caption">New Follow-up</Typography>
                  <TextField
                    type="date"
                    focused
                    name={`Follow-up ${followUpCount + 1} Date`}
                    value={
                      newFollowUp[`Follow-up ${followUpCount + 1} Date`] || ""
                    }
                    onChange={(e) => {
                      setNewFollowUp((prev) => ({
                        ...prev,
                        [`Follow-up ${followUpCount + 1} Date`]: e.target.value,
                      }));
                    }}
                    fullWidth
                    label="Follow-up Date"
                  />
                  <TextField
                    name={`Follow-up ${followUpCount + 1} Remark`}
                    value={
                      newFollowUp[`Follow-up ${followUpCount + 1} Remark`] || ""
                    }
                    onChange={(e) => {
                      setNewFollowUp((prev) => ({
                        ...prev,
                        [`Follow-up ${followUpCount + 1} Remark`]:
                          e.target.value,
                      }));
                    }}
                    fullWidth
                    label="Follow-up Remark"
                  />
                  <TextField
                    type="date"
                    focused
                    name={`Next Follow-up ${followUpCount + 1} Date`}
                    value={
                      newFollowUp[`Next Follow-up ${followUpCount + 1} Date`] ||
                      ""
                    }
                    onChange={(e) => {
                      setNewFollowUp((prev) => ({
                        ...prev,
                        [`Next Follow-up ${followUpCount + 1} Date`]:
                          e.target.value,
                      }));
                    }}
                    fullWidth
                    label="Next Follow-up Date"
                  />
                  <Button variant="outlined" onClick={handleAddNewFollowup}>
                    Add Follow-up
                  </Button>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="CF_AccordionSummary"
                expandIcon={<ExpandMore />}
              >
                Files
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={2} fullWidth>
                  {[1, 2, 3, 4]?.map((r_count) => {
                    return (
                      <>
                        {formData[`File ${r_count} URL`]?.length > 0 ? (
                          <Box className="recording_details_wrapper">
                            <Typography variant="subtitle1">
                              <b>File {r_count} </b>
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              className="recording_info_subtitle2"
                            >
                              <u>Name</u>: {formData[`File ${r_count} Name`]}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              className="recording_info_subtitle2"
                            >
                              <u>Category</u>:{" "}
                              {formData[`File ${r_count} Category`] ?? "None"}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              className="recording_info_subtitle2"
                            >
                              <u>URL</u>:{" "}
                              <a
                                href={formData[`File ${r_count} URL`]}
                                target="_blank"
                              >
                                {" "}
                                Open File
                              </a>
                            </Typography>
                          </Box>
                        ) : (
                          <Box fullWidth>
                            <Typography variant="subtitle2" marginBottom={1}>
                              File {r_count}{" "}
                              {r_count === 1 ? "(Test Drive)" : ""}
                            </Typography>
                            <Box
                              fullWidth
                              className="audio_input_button_wrapper"
                            >
                              <Button
                                variant="outlined"
                                className="audio_recording_form_button"
                                onClick={() => {
                                  setAudioPopupNumber(r_count);
                                  setShowRecordPopup(true);
                                }}
                              >
                                Record
                              </Button>
                              <Button
                                variant="outlined"
                                className="audio_recording_form_button"
                                onClick={() => {
                                  setAudioPopupNumber(r_count);
                                  setShowUploadPopup(true);
                                }}
                              >
                                Upload
                              </Button>
                            </Box>
                          </Box>
                        )}
                        {r_count < 4 && <Divider />}
                      </>
                    );
                  })}
                </Stack>
              </AccordionDetails>
            </Accordion>
          </Stack>
          <Stack direction={"row"} mt={2} spacing={2}>
            <InputLabel>Support Required</InputLabel>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="center">
            <FormControlLabel
              className="support_checkbox_label"
              control={
                <Checkbox
                  name="Yogesh Moondra"
                  checked={
                    formData?.["Support Required"]
                      ?.split(",")
                      ?.includes("Yogesh Moondra") || false
                  }
                  onChange={handleCheckboxChange}
                />
              }
              label="Yogesh Moondra"
            />
            <FormControlLabel
              className="support_checkbox_label"
              control={
                <Checkbox
                  name="Nishant Vyas"
                  checked={
                    formData?.["Support Required"]
                      ?.split(",")
                      ?.includes("Nishant Vyas") || false
                  }
                  onChange={handleCheckboxChange}
                />
              }
              label="Nishant Vyas"
            />
          </Stack>
          {missingFields?.length > 0 && (
            <Alert icon={<PriorityHigh fontSize="inherit" />} severity="error">
              Missing Required Fields : {missingFields?.join(", ")}
            </Alert>
          )}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            className="SubmitFormButton"
          >
            {loading ? <CircularProgress /> : "Submit"}
          </Button>
        </form>
      </Container>
      <Dialog open={responsePC?.prospectCardNo}>
        <DialogContent>
          <Typography variant="subtitle1">
            {responsePC?.message} Prospect Card: {responsePC?.prospectCardNo}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setResponsePC({ prospectCardNo: null, message: "" });
              setCurrentTab(null);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <UnsavedPopup
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
        setShowUnsavedPopup={setShowUnsavedPopup}
        showUnsavedPopup={showUnsavedPopup}
        handlePopupExit={handlePopupExit ?? handleExit}
      />
      <AudioRecording
        showRecordPopup={showRecordPopup}
        setShowRecordPopup={setShowRecordPopup}
        audioPopupNumber={audioPopupNumber}
        setAudioPopupNumber={setAudioPopupNumber}
        // setRecordings={setRecordings}
        setFormData={setFormData}
        categories={appFields?.["File Categories"]}
      />
      <AudioUploadComponent
        showUploadPopup={showUploadPopup}
        setShowUploadPopup={setShowUploadPopup}
        audioPopupNumber={audioPopupNumber}
        setAudioPopupNumber={setAudioPopupNumber}
        // setRecordings={setRecordings}
        setFormData={setFormData}
        categories={appFields?.["File Categories"]}
      />
    </>
  );
};

export default CustomerForm;
